import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LibrarySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LibrarySVG;
